import { useState, useRef, useEffect } from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Portfolio, Footer, Experience, Navbar } from "../../components";
import BannerVideo from "../../assets/image/Bannr-Video-GEM.mp4"
import {
  HomeLogoVideos,
  VoteSlider,
  HomeTalent,
  HomeCategories,
  HomeEvent,
  HomeNews,
  HomeProjects,
  HomeJobs,
  HomeTeam,
  HomeAgency,
  HomeBannerVideoPlayer,
} from "../index";
import Functions from "./index.function";

const Home = () => {
  const { settings } = Functions();
  const [isMuted, setIsMuted] = useState(false); // Start unmuted
  const videoRef = useRef(null);

  useEffect(() => {
    // Attempt to play unmuted
    if (videoRef.current) {
      videoRef.current.muted = false;
      videoRef.current.play()
        .then(() => {
          // Success! Video is playing unmuted
          setIsMuted(false);
        })
        .catch((error) => {
          // Browser blocked unmuted autoplay, fall back to muted
          console.log("Unmuted autoplay blocked, playing muted:", error);
          videoRef.current.muted = true;
          videoRef.current.play();
          setIsMuted(true);
        });
    }
  }, []);

  const toggleMute = () => {
    if (videoRef.current) {
      videoRef.current.muted = !isMuted;
      setIsMuted(!isMuted);
    }
  };

  return (
    <div className="bg-primary">
      <div className="relative overflow-hidden">
        <div className="absolute top-0 left-0 w-full">
          <Navbar />
        </div>
        
        {/* VIDEO WITH STYLED BUTTON */}
        {/* <div className="relative w-full mb-10">
          <video 
            ref={videoRef}
            loop 
            playsInline 
            className="banner-video w-full"
          >
            <source src={BannerVideo} type="video/mp4" />
          </video>

          <button
            onClick={toggleMute}
            className="absolute xs:bottom-3 xs:right-3 sm:bottom-4 sm:right-4 lg:bottom-6 lg:right-6
              bg-white bg-opacity-10 backdrop-blur-md border border-white border-opacity-20 
              hover:bg-opacity-20 text-white rounded-full 
              xs:p-2 sm:p-2.5 lg:p-3
              shadow-xl transition-all duration-300 transform hover:scale-110 z-10"
            aria-label={isMuted ? "Unmute video" : "Mute video"}
          >
            {isMuted ? (
              <svg 
                xmlns="http://www.w3.org/2000/svg" 
                className="xs:h-5 xs:w-5 sm:h-5 sm:w-5 lg:h-6 lg:w-6" 
                fill="none" 
                viewBox="0 0 24 24" 
                stroke="currentColor"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z M17 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2" 
                />
              </svg>
            ) : (
              <svg 
                xmlns="http://www.w3.org/2000/svg" 
                className="xs:h-5 xs:w-5 sm:h-5 sm:w-5 lg:h-6 lg:w-6" 
                fill="none" 
                viewBox="0 0 24 24" 
                stroke="currentColor"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M15.536 8.464a5 5 0 010 7.072m2.828-9.9a9 9 0 010 12.728M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z" 
                />
              </svg>
            )}
          </button>
        </div> */}
         <HomeBannerVideoPlayer  />
      </div>
      
     
      <HomeLogoVideos />
      <VoteSlider />
      <HomeTalent />
      <HomeCategories />
      <HomeEvent />
      <HomeNews />
      <HomeProjects />
      <HomeJobs />
      <HomeTeam />
      <HomeAgency />
      <Experience />
      <Footer />
    </div>
  );
};

export default Home;